import React, { Component } from 'react';
import Manifest from './Manifest.js'

class Formula extends Component {
    constructor(props) 
    {
        super(props)

        this.state = {
            application: props.application,
            updateApp: props.updateApp,
            formula: props.formula,
            cache: props.application.engine.cache(),
            network: props.application.engine.network(),
            evalResult: "",
            dataTogglePopup: props.dataTogglePopup,
        }

        this.handleEval = this.handleEval.bind(this)
        
    }

    
    handleEval(event)
    {
        let btn = event.target
        let btn_caption = event.target.innerHTML

        event.target.innerHTML = "evaluating...";

        this.state.application.engine.eval(this.state.formula).then( result => {

            this.setState({
                evalResult: result.status
            })
            
            this.state.updateApp()

            btn.innerHTML = btn_caption
        });
    }

    getDependencies()
    {
        let FromulaDependency = ""

        let dependencies = this.props.formula.get_dependencies()

        if (0 === dependencies.data.length)
        {
            if ("ok" !== dependencies.status)
                FromulaDependency = "Error getting dependency: " + dependencies.status
            else
                FromulaDependency = "Has no dependency"
        }
        else
            FromulaDependency = dependencies.data.map(dep => <div>{dep.ArgName}<Manifest application={this.state.application} dataTogglePopup={this.state.dataTogglePopup} updateApp={this.state.updateApp} manifest={{data:dep,status:"ok"}} /></div>)
        
        return FromulaDependency
    }

    render()
    {
        return (
            <div className="col-md-12">
                <button className="btn btn-sm btn-warning m-2" onClick={this.handleEval}>Evaluate Formula</button>
               
                <div className="border-bottom m-2"></div>
            {this.state.evalResult}
            {this.getDependencies()}
            </div>
        );
    }
}

export default Formula;